// Pure date-only helpers for the Dispatch Panel.
// These NEVER perform timezone conversion. The stored value may be a plain
// "YYYY-MM-DD" string OR a full ISO datetime ("YYYY-MM-DDTHH:mm:ss"); in both cases
// only the calendar-date part is used, so the exact date the user picked is shown
// identically everywhere (table, view, edit modal, analytics) with no ±1-day shift.

// Returns "YYYY-MM-DD" suitable for an <input type="date"> value.
export const toDateInput = (value) => (value ? String(value).substring(0, 10) : "");

// Returns "DD MMM YYYY" (e.g. "18 Jun 2026") built from the date parts only.
export const toDMY = (value) => {
  if (!value) return "—";
  const [y, m, d] = String(value).substring(0, 10).split("-");
  if (!y || !m || !d) return String(value);
  // Constructed in LOCAL time from explicit parts → formatted date equals the parts,
  // independent of the browser/server timezone.
  return new Date(Number(y), Number(m) - 1, Number(d)).toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};
